import * as React from "react";
import { LobFormsProps } from "src/components/shared/StorefrontWizard/LobForm";
import { Wizard } from "src/components/shared/Wizard/Wizard";
import { ItemKeyHelper } from "src/components/utility/ItemKeyHelper";

/**
 * Wrapping lob forms in the Wizard component which is the one in charge of deside
 * Whether the lob needs to be rendered or not base on the wizardState => activeLob
 */
export const LobForms: React.FunctionComponent<LobFormsProps> = ({ lobForms }) => {
  const keyHelper = new ItemKeyHelper("storefrontForms");

  return (
    <>
      {lobForms.map((lob: React.ReactElement) => (
        <Wizard key={keyHelper.next()} lobName={lob.props.flexTemplateNode.options.flexComponentName}>
          {lob}
        </Wizard>
      ))}
    </>
  );
};
